import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import en from './i18n/en';
import fr from './i18n/fr';
import store from '../store/index';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { en, fr },
        current: store.getters.getLocale,
    },
});


